import React, { useState, useRef, useEffect } from 'react';
import caretDown from '../../assets/caret-down.svg';
// import Loader from '../Loader';
import PropTypes from 'prop-types';

function DropdownButton({
    title,
    disabled,
    children,
    loading,
}) {
    // State to manage the visibility of the dropdown
    const [isOpen, setIsOpen] = useState(false);

    const dropdownRef = useRef(null);

    // Function to toggle the dropdown visibility
    const toggleDropdown = () => {
        if (disabled) {
            return;
        }
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        // Attach event listener when the component mounts
        document.addEventListener('mousedown', handleClickOutside);

        // Detach event listener when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="dropdown position-relative" ref={dropdownRef}>
            <button
                className={`btn ${disabled ? 'btn-secondary' : 'btn-primary'} text-white d-flex align-items-center px-3 py-2 rounded`}
                style={{ maxHeight: '40px', width: '110px' }}
                onClick={toggleDropdown}
                disabled={disabled}
            >
                {loading ? (
                    <div className="d-flex justify-content-center w-100">
                        {/* <Loader show={loading} light={true} /> */}
                    </div>
                ) : (
                    <div className='d-flex justify-content-center align-items-center'>
                        <div>{title}</div>
                        <div style={{ width: '16px', marginLeft: '8px' }}>
                            <img src={caretDown} alt="Caret Down" className="img-fluid" />
                        </div>
                    </div>
                )}
            </button>
            {isOpen && (
                <div className="dropdown-menu dropdown-menu-end show mt-2 me-4 rounded shadow">
                    {children}
                </div>
            )}
        </div>
    );
}

DropdownButton.propTypes = {
    title: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    children: PropTypes.node.isRequired,
    loading: PropTypes.bool,
};

DropdownButton.defaultProps = {
    disabled: false,
    loading: false,
};

export default DropdownButton;
